import type { UtilityContext } from '@change-corgi/core-react/utilityContext';

import type { MediaHitComment } from '../../shared/context';

import {
	PetitionDetailsMediaHitsPage,
	type PetitionDetailsMediaHitsPageQuery,
	type PetitionDetailsMediaHitsPageQueryVariables,
} from './index.graphql';

export type MediaHitsPage = Readonly<{
	// null when there is no further page (same convention as SPH's getMediaHits)
	endCursor: string | null;
	mediaHits: readonly MediaHitComment[];
	totalCount: number;
}>;

export async function getMediaHitsPage(
	petitionId: string,
	{ first, cursor }: { first: number; cursor?: string },
	{ gql: { fetch } }: UtilityContext,
): Promise<MediaHitsPage | undefined> {
	try {
		const { data } = await fetch<PetitionDetailsMediaHitsPageQuery, PetitionDetailsMediaHitsPageQueryVariables>({
			query: PetitionDetailsMediaHitsPage,
			variables: { petitionId, first, cursor },
			rejectOnError: true,
			batched: false,
		});

		const connection = data.petition?.mediaHitsConnection;
		if (!connection) return undefined;

		return {
			mediaHits: connection.nodes.map(({ id, url, mediaSource }) => ({ id, url, mediaSource })),
			endCursor: connection.pageInfo.hasNextPage ? (connection.pageInfo.endCursor ?? null) : null,
			totalCount: connection.totalCount,
		};
	} catch {
		return undefined;
	}
}
